// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../src/images/committees/covers/UNSC.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../src/images/committees/covers/WHO.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../src/images/committees/covers/WORLD BANK.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../src/images/committees/covers/UNODC.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../src/images/committees/covers/UNFCCC_COP.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../src/images/committees/covers/UNDP.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../src/images/committees/covers/IPC.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../src/images/committees/covers/ILC.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../src/images/committees/covers/AIPPM.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../src/images/committees/covers/COPUOS.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../src/images/committees/covers/UNGA.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../src/images/committees/covers/UNHRC.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../src/images/committees/agendas/UNSC agenda.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../src/images/committees/agendas/who agenda.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../src/images/committees/agendas/World bank agenda_.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../src/images/committees/agendas/UNODC agenda.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../../src/images/committees/agendas/UNFCCC_COP Agenda.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../../src/images/committees/agendas/UNDP AGENDA.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../../src/images/committees/agendas/IPC agenda.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../src/images/committees/agendas/ILC agenda.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../../src/images/committees/agendas/AIPPM AGENDA.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../../src/images/committees/agendas/COPUOS agenda.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../../src/images/committees/agendas/UNGA Agenda.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../../src/images/committees/agendas/UNHRC agenda.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../images/collabration/collabrations2024/lytads.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../images/collabration/collabrations2024/looks_salon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../images/collabration/collabrations2024/amaha.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../images/collabration/collabrations2024/image.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../images/collabration/collabrations2024/sultansdeli.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../images/collabration/collabrations2024/RiseUp.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../images/collabration/collabrations2024/tiivra.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../images/collabration/collabrations2024/bikaji.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../images/collabration/collabrations2024/inc5.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../images/collabration/collabrations2024/sqube.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Home Page */

.hero__banner img {
  width: 30%;
  height: auto;
}

.hero__banner {
  display: flex;
  justify-content: center;
  margin-top: 20p x;
}

.hero__banner img {
  align-content: center;
  border-radius: 20px;
  height: auto;
  width: 99%;
}

.google-map {
  height: 500px;
  width: 100%;
  max-width: 1100px;
  z-index: 0;
}

.about-event {
  max-width: 1250px;
  margin: auto;
  display: grid;
  align-items: center;
}

.about-event__text {
  padding: 3.5% 7%;
  display: flex;
  flex-direction: column;
  gap: 2em;
}

.about-event__text--body {
  line-height: 1.5;
}

.about-event__text--header {
  display: flex;
  flex-direction: column;
  gap: 0.5em;
}

h5 {
  font-size: 0.95em;
  font-weight: 300;
  color: rgb(110, 110, 110);
}

.event-venue {
  display: grid;
  padding: 3.5% 7%;
  gap: 2em;
}

.event-venue__text {
  display: flex;
  flex-direction: column;
  gap: 1em;
}

.about-event__image {
  width: 100%;
}

.priority, .priority-2 {
  background-color: #03045e;
  padding: 2.5% 7%;
  margin: 0% 7%;
  color: white;
  font-weight: 550;
  text-align: center;
  font-size: 1em;
  border-radius: 20px;
  margin-top: 1rem;
  display: block;
  text-decoration: none;
  position: relative;
  transition: transform 0.3s ease, background-color 0.3s ease;
}
.disabled {
  cursor: not-allowed;
}
.hover-text {
  display: none;
}
.original-text {
  display: inline;
}
.disabled:hover {
  background-color: rgba(108, 117, 125, 0.5);
  color: white;
  transform: scale(1.05);
}
.disabled:hover .original-text {
  display: none;
}
.disabled:hover .hover-text {
  display: inline;
}
.priority-2 {
  background-color: #0077b6;
  padding: 2.5% 7%;
  margin: 0% 7%;
  color: white;
  font-weight: 550;
  text-align: center;
  font-size: 1em;
  border-radius: 20px;
  margin-top: 1rem;
  display: block;
  text-decoration: none;
  position: relative;
  transition: transform 0.3s ease, background-color 0.3s ease;
}

.priority {
  background-color: #03045e;
  padding: 2.5% 7%;
  margin: 0% 7%;
  color: white;
  font-weight: 550;
  text-align: center;
  font-size: 1em;
  border-radius: 20px;
  margin-top: 1rem;
  display: block;
  text-decoration: none;
  transition: transform 0.3s ease, background-color 0.3s ease;
}

.priority-2 {
  background-color: #0077b6;
  padding: 2.5% 7%;
  margin: 0% 7%;
  color: white;
  font-weight: 550;
  text-align: center;
  font-size: 1em;
  border-radius: 20px;
  margin-top: 1rem;
  display: block;
  text-decoration: none;
  transition: transform 0.3s ease, background-color 0.3s ease;
}

.priority:hover,
.priority-2:hover {
  background-color: #5b5f64;
  color: white;
  transform: scale(1.05);

}

.priority a,
.priority-2 a {
  color: white;
}

/* .priority:hover a, .priority-2:hover a {
  color: rgb(255, 0, 0); 
} */

/* Events Page */

.panelists {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin: auto;
  max-width: 70ch;
  text-align: center;
  font-size: 30px;
  padding-top: 100px;
  padding-bottom: 200px;
}



.panelist {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

.panelist img {
  height: 200px;
  width: 200px;
  margin: auto;
}

/* Conference Page */

.cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  margin: 1rem;
}


.card {
  width: 200px;
  padding: 1rem;
  border-radius: 10px;
  color: white;
}

.card .info {
  margin-top: 1rem;
  text-shadow: 1px 1px 2px black;
}

/* .card .info h4 { */
/* text-transform: uppercase; */
/* } */

/* 
.info-agenda h3 {
  background-color: #03045e;
  border-radius: 15px; 
  border: 2px solid #03045e;
  margin: 10px 10px 10px;
} */



.card img {
  width: 100%;
  height: 150px;
  border-radius: 10px;
  object-fit: cover;
}

.card-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  margin: 0 auto;
  max-width: 1200px;
  padding: 20px;
}

.comm-cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  gap: 20px;
  width: 100%;
}

/* .committee-card {
  background-color: #357ABD;
  color: #fff;
  padding: 30px;
  border-radius: 15px;
  width: 320px;
  height: 280px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}
.committee-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
} */

/* .committee-card {
  background-image: url(../../src/images/committees/covers/UNSC.jpg);
  background-size: cover;
  background-position: center;
  background-color: #357ABD;
  color: #fff;
  padding: px;
  border-radius: 15px;
  width: 320px;
  aspect-ratio: 1;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: transform 0.2s ease-in-out, 
              box-shadow 0.2s ease-in-out,
              background-image 0.2s ease-in-out;
}
.committee-card:hover {
  transform: translateY(-5px);
  box-shadow: -3px 3px 15px 2px rgba(0, 0, 0, 0.2);
  background-image: url(../../src/images/committees/agendas/UNSC\\ agenda.jpg);
} */

.committee-card {
  background-size: cover;
  background-position: center;
  background-color: #357ABD;
  color: #fff;
  padding: 20px;
  border-radius: 15px;
  width: 320px;
  aspect-ratio: 1;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: transform 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out,
    background-image 0.2s ease-in-out;
  position: relative;
  /* Positioning for overlay */
  overflow: hidden;
  /* Hide overflow for the overlay */
}

.committee-card:hover {
  transform: translateY(-5px);
  box-shadow: -3px 3px 15px 2px rgba(0, 0, 0, 0.2);
}

/* Add an overlay with "Click for agenda" text */
/* .committee-card::before {
  content: "Click for agenda";
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  color: white;
  font-size: 1.2rem;
  font-weight: bold;
  transition: opacity 0.2s ease-in-out;
  opacity: 1; 
} */

/* Hide overlay on hover */
/* .committee-card:hover::before {
  opacity: 0;
} */
/* Default state (covers) */
.committee-card[data-committee="unsc"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.committee-card[data-committee="who"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.committee-card[data-committee="wbnk"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.committee-card[data-committee="unodc"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.committee-card[data-committee="unfccc"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.committee-card[data-committee="undp"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.committee-card[data-committee="ipc"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.committee-card[data-committee="ilc"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.committee-card[data-committee="aippm"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.committee-card[data-committee="copuos"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.committee-card[data-committee="unga"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.committee-card[data-committee="unhrc"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}



/* Hover state (agendas) */
.committee-card:hover[data-committee="unsc"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.committee-card:hover[data-committee="who"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}

.committee-card:hover[data-committee="wbnk"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

.committee-card:hover[data-committee="unodc"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.committee-card:hover[data-committee="unfccc"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

.committee-card:hover[data-committee="undp"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}

.committee-card:hover[data-committee="ipc"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

.committee-card:hover[data-committee="ilc"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}

.committee-card:hover[data-committee="aippm"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}

.committee-card:hover[data-committee="copuos"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}

.committee-card:hover[data-committee="unga"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}

.committee-card:hover[data-committee="unhrc"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}


.committee-card h2 {
  font-size: 1.5em;
  font-family: 'Arial', sans-serif;
  margin-bottom: 15px;
}

.committee-card h3 {
  font-size: 1.2em;
  font-family: 'Arial', sans-serif;
  line-height: 1.5em;
  margin: 0;
}

.committee-card-ipc {
  background-color: #357ABD;
  color: #fff;
  padding: 30px;
  border-radius: 15px;
  width: 320px;
  height: inherit;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.committee-card-ipc:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.info-agendas {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: center;
}

.info-agendas-ipc {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: center;
}

.cards.leadership-team {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
}

.sec-gen,
.director-general,
.deputy-sec-gen,
.chief-staff,
.chief-info {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  width: 100%;
}



@media (max-width: 768px) {

  .cards,
  .sec-gen,
  .director-general,
  .deputy-sec-gen,
  .chief-staff,
  .chief-info {
    justify-content: space-between;
  }

  .card {
    width: 45%;
  }
}

@media (max-width: 480px) {
  .card {
    width: 100%;
  }

  .committee-card {
    width: 100%;

  }

  .about-event__text {
    display: flex;
    flex-wrap: wrap;
  }
}

@media screen and (min-width: 395px) {
  .about-event__text {
    display: flex;
    flex-wrap: wrap;
  }
}

.cardheads {
  margin-left: 3rem;
  font-size: 24px;
}

.cardhead {
  font-size: 28px;
  margin-left: 0rem;
}

/* Card colours for committees */

.aippm {
  background-color: #af749c;
}

.disec {
  background-color: #d17e62;
}

.sochum {
  background-color: #b97991;
}

.unsc {
  background-color: #951c25;
}

.undp {
  background-color: #54968a;
}

.press {
  background-color: #dfab1a;
}


/* Card colours for Secretariat */
.leadership-team .card {
  background-color: #03045E;
}

.bdm>.card {
  background-color: #0C1D6F;
}

.ihc>.card {
  background-color: #143680;
}

.cnd>.card {
  background-color: #1D4E90;
}

.hospi>.card {
  background-color: #2667A1;
}

.logi>.card {
  background-color: #2E80B2;
}

.pr>.card {
  background-color: #3799C3;
}

.rnd>.card {
  background-color: #3FB1D3;
}

.tech>.card {
  background-color: #48CAE4;
}

.committees {
  display: flex;
  flex-direction: column;
  grid-gap: 2rem;
  gap: 2rem;
  margin: auto;
  max-width: 70ch;
  text-align: center;
  font-size: 30px;
  padding-top: 100px;
  padding-bottom: 200px;
}



/* Media queries */
@media screen and (min-width: 1100px) {
  .priority {
    font-size: 1.2em;
  }

  .priority-2 {
    font-size: 1.2em;
  }

  .events-schedule {
    gap: 40px
  }
}

@media screen and (max-width: 1100px) {
  .events-schedule {
    gap: 0px
  }

  .eventstab {
    margin-top: 50px;
  }
}

@media only screen and (max-width: 600px) {
  .panelist {
    flex-direction: column-reverse;
  }

  .card {
    width: 130px;
  }

  .card h3,
  h4 {
    font-size: 0.8rem;
  }

  .card img {
    height: 100px;
  }
}

.heading-wrapper {
  font-family: "Unbounded", sans-serif;
  color: #0f4c90;
  font-weight: 700;
  font-size: 0.8em;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2rem;
}

.privacy-policy {
  width: 80%;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Arial', sans-serif;
}

.privacy-policy h1 {
  color: #333;
  margin-bottom: 1rem;
}

.privacy-policy h2 {
  color: #555;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
}

.privacy-policy p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 1rem;
}

.privacy-policy p.date {
  font-style: italic;
  margin-bottom: 2rem;
}

.privacy-policy ul {
  list-style: disc inside;
  margin: 1rem 0;
  padding-left: 1rem;
}

.privacy-policy li {
  margin-bottom: 0.5rem;
  color: #666;
}

/* sponsors css*/
.spon-card {
  background-size: contain; 
  background-position: center;
  background-repeat: no-repeat;
  color: #fff;
  border-radius: 15px;
  border: 1px solid #143680;
  width: 230px;
  aspect-ratio: 1;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: transform 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out,
    background-image 0.2s ease-in-out,
    opacity 0.2s ease-in-out;
  position: relative;
  overflow: hidden;
}

.spon-card:hover {
  transform: translateY(-10px);
  opacity: 1;
  /* Increase opacity on hover */
}

/* Overlay for the sponsor name */
.spon-name {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  /* Semi-transparent black background */
  color: white;
  padding: 10px;
  font-size: 1.2em;
  text-align: center;
  opacity: 0;
  /* Hidden by default */
  transition: opacity 0.3s ease-in-out;
}

.spon-card:hover .spon-name {
  opacity: 1;
  /* Show the sponsor name on hover */
}


.spon-card[data-spon="lytads"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}

.spon-card[data-spon="lookssalon"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}

.spon-card[data-spon="amaha"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}

.spon-card[data-spon="ilw"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}

.spon-card[data-spon="sultansdeli"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
}

.spon-card[data-spon="riseup"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
}

.spon-card[data-spon="tiivra"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
}

.spon-card[data-spon="bikaji"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
}

.spon-card[data-spon="inc5"] {
 
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
}

.spon-card[data-spon="sqube"] {
 
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
}


.spon-card-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  margin: 0 auto;
  max-width: 1200px;
  padding: 20px;
}

.spon-cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  gap: 20px;
  width: 100%;
}

/* sponsor css end */

.events-schedule {
  /* height: 600px; */
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.schedule-text {
  color: white;
  text-align: left;
  padding-left: 10px;
  padding-right: 10px;
}

.schedule-items {
  border-radius: 5px;
  padding-left: 20px;
  padding-top: 15px;
  margin-bottom: 3px;
  padding-bottom: 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.schedule-items:nth-child(odd) {
  background-color: #155498;
}

.schedule-items:hover {
  background-color: #2565ad;
}

.schedule-event {
  font-weight: bold;
  margin-left: 5px;
}

.schedule-pic {
  height: 450px;
  width: 100%;
  margin-top: 10px;
  border-radius: 20px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}

.eventstab {
  height: 500px;
  width: 315px;
  text-align: center;
  border-radius: 20px;
  background-color: #0e4a8f;
}

.eventstab h2 {
  margin-top: 20px;
  color: white;
}

.vertical-line {
  background-color: black;
  border-radius: 1px;
  margin-top: 30px;
  width: 2px;
  height: 540px;
}

.all-events {
  margin-top: 20px;
  margin-bottom: 20px;
}

.events-item {
  display: flex;
  flex-wrap: wrap;
  padding-top: 15px;
  padding-bottom: 15px;
  justify-content: center;
  gap: 50px;
}



.event-headings {
  color: #0e4c8f;
  font-size: 40px;
}

.events-item p {
  font-size: 18px;
  padding-top: 20px;
  padding-bottom: 20px;
}

.events-img {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.events-img img {
  height: auto;
  width: 95%;
  border-radius: 20px;
}

@media screen and (max-width: 1220px) {
  .events-text {
    order: 1;
  }

  .events-img {
    order: 2;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,2DAA2D;AAC7D;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,0CAA0C;EAC1C,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,2DAA2D;AAC7D;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;;AAExB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;GAEG;;AAEH,gBAAgB;;AAEhB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;;;AAIA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA,oBAAoB;;AAEpB;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;;AAGA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,qBAAqB;AACrB,+BAA+B;AAC/B,MAAM;;AAEN;;;;;;GAMG;;;;AAIH;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,SAAS;EACT,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;;;GAiBG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;GAuBG;;AAEH;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB;;qCAEmC;EACnC,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA,gDAAgD;AAChD;;;;;;;;;;;;;;;;GAgBG;;AAEH,0BAA0B;AAC1B;;GAEG;AACH,2BAA2B;AAC3B;EACE,yDAAkE;AACpE;;AAEA;EACE,yDAAiE;AACnE;;AAEA;EACE,yDAAyE;AAC3E;;AAEA;EACE,yDAAmE;AACrE;;AAEA;EACE,yDAAwE;AAC1E;;AAEA;EACE,yDAAkE;AACpE;;AAEA;EACE,yDAAiE;AACnE;;AAEA;EACE,yDAAiE;AACnE;;AAEA;EACE,yDAAmE;AACrE;;AAEA;EACE,yDAAoE;AACtE;;AAEA;EACE,0DAAkE;AACpE;;AAEA;EACE,0DAAmE;AACrE;;;;AAIA,0BAA0B;AAC1B;EACE,0DAA2E;AAC7E;;AAEA;EACE,0DAA0E;AAC5E;;AAEA;EACE,0DAAmF;AACrF;;AAEA;EACE,0DAA4E;AAC9E;;AAEA;EACE,0DAAiF;AACnF;;AAEA;EACE,0DAA2E;AAC7E;;AAEA;EACE,0DAA0E;AAC5E;;AAEA;EACE,0DAA0E;AAC5E;;AAEA;EACE,0DAA4E;AAC9E;;AAEA;EACE,0DAA6E;AAC/E;;AAEA;EACE,0DAA2E;AAC7E;;AAEA;EACE,0DAA4E;AAC9E;;;AAGA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mEAAmE;AACrE;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;;;;;EAKE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,WAAW;AACb;;;;AAIA;;EAEE;;;;;;IAME,8BAA8B;EAChC;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;;EAEb;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,gCAAgC;;AAEhC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA,iCAAiC;AACjC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,SAAS;EACT,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;;;AAIA,kBAAkB;AAClB;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB;;;4BAG0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,UAAU;EACV,8BAA8B;AAChC;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,oCAAoC;EACpC,sCAAsC;EACtC,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,mCAAmC;AACrC;;;AAGA;EACE,0DAA0E;AAC5E;;AAEA;EACE,0DAA+E;AACjF;;AAEA;EACE,0DAAyE;AAC3E;;AAEA;EACE,0DAAyE;AAC3E;;AAEA;EACE,0DAA+E;AACjF;;AAEA;EACE,0DAA0E;AAC5E;;AAEA;EACE,0DAA0E;AAC5E;;AAEA;EACE,0DAA0E;AAC5E;;AAEA;;EAEE,0DAAwE;AAC1E;;AAEA;;EAEE,0DAAyE;AAC3E;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,SAAS;EACT,WAAW;AACb;;AAEA,oBAAoB;;AAEpB;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,SAAS;AACX;;;;AAIA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF","sourcesContent":["/* Home Page */\n\n.hero__banner img {\n  width: 30%;\n  height: auto;\n}\n\n.hero__banner {\n  display: flex;\n  justify-content: center;\n  margin-top: 20p x;\n}\n\n.hero__banner img {\n  align-content: center;\n  border-radius: 20px;\n  height: auto;\n  width: 99%;\n}\n\n.google-map {\n  height: 500px;\n  width: 100%;\n  max-width: 1100px;\n  z-index: 0;\n}\n\n.about-event {\n  max-width: 1250px;\n  margin: auto;\n  display: grid;\n  align-items: center;\n}\n\n.about-event__text {\n  padding: 3.5% 7%;\n  display: flex;\n  flex-direction: column;\n  gap: 2em;\n}\n\n.about-event__text--body {\n  line-height: 1.5;\n}\n\n.about-event__text--header {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5em;\n}\n\nh5 {\n  font-size: 0.95em;\n  font-weight: 300;\n  color: rgb(110, 110, 110);\n}\n\n.event-venue {\n  display: grid;\n  padding: 3.5% 7%;\n  gap: 2em;\n}\n\n.event-venue__text {\n  display: flex;\n  flex-direction: column;\n  gap: 1em;\n}\n\n.about-event__image {\n  width: 100%;\n}\n\n.priority, .priority-2 {\n  background-color: #03045e;\n  padding: 2.5% 7%;\n  margin: 0% 7%;\n  color: white;\n  font-weight: 550;\n  text-align: center;\n  font-size: 1em;\n  border-radius: 20px;\n  margin-top: 1rem;\n  display: block;\n  text-decoration: none;\n  position: relative;\n  transition: transform 0.3s ease, background-color 0.3s ease;\n}\n.disabled {\n  cursor: not-allowed;\n}\n.hover-text {\n  display: none;\n}\n.original-text {\n  display: inline;\n}\n.disabled:hover {\n  background-color: rgba(108, 117, 125, 0.5);\n  color: white;\n  transform: scale(1.05);\n}\n.disabled:hover .original-text {\n  display: none;\n}\n.disabled:hover .hover-text {\n  display: inline;\n}\n.priority-2 {\n  background-color: #0077b6;\n  padding: 2.5% 7%;\n  margin: 0% 7%;\n  color: white;\n  font-weight: 550;\n  text-align: center;\n  font-size: 1em;\n  border-radius: 20px;\n  margin-top: 1rem;\n  display: block;\n  text-decoration: none;\n  position: relative;\n  transition: transform 0.3s ease, background-color 0.3s ease;\n}\n\n.priority {\n  background-color: #03045e;\n  padding: 2.5% 7%;\n  margin: 0% 7%;\n  color: white;\n  font-weight: 550;\n  text-align: center;\n  font-size: 1em;\n  border-radius: 20px;\n  margin-top: 1rem;\n  display: block;\n  text-decoration: none;\n  transition: transform 0.3s ease, background-color 0.3s ease;\n}\n\n.priority-2 {\n  background-color: #0077b6;\n  padding: 2.5% 7%;\n  margin: 0% 7%;\n  color: white;\n  font-weight: 550;\n  text-align: center;\n  font-size: 1em;\n  border-radius: 20px;\n  margin-top: 1rem;\n  display: block;\n  text-decoration: none;\n  transition: transform 0.3s ease, background-color 0.3s ease;\n}\n\n.priority:hover,\n.priority-2:hover {\n  background-color: #5b5f64;\n  color: white;\n  transform: scale(1.05);\n\n}\n\n.priority a,\n.priority-2 a {\n  color: white;\n}\n\n/* .priority:hover a, .priority-2:hover a {\n  color: rgb(255, 0, 0); \n} */\n\n/* Events Page */\n\n.panelists {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  margin: auto;\n  max-width: 70ch;\n  text-align: center;\n  font-size: 30px;\n  padding-top: 100px;\n  padding-bottom: 200px;\n}\n\n\n\n.panelist {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.panelist img {\n  height: 200px;\n  width: 200px;\n  margin: auto;\n}\n\n/* Conference Page */\n\n.cards {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 1rem;\n  margin: 1rem;\n}\n\n\n.card {\n  width: 200px;\n  padding: 1rem;\n  border-radius: 10px;\n  color: white;\n}\n\n.card .info {\n  margin-top: 1rem;\n  text-shadow: 1px 1px 2px black;\n}\n\n/* .card .info h4 { */\n/* text-transform: uppercase; */\n/* } */\n\n/* \n.info-agenda h3 {\n  background-color: #03045e;\n  border-radius: 15px; \n  border: 2px solid #03045e;\n  margin: 10px 10px 10px;\n} */\n\n\n\n.card img {\n  width: 100%;\n  height: 150px;\n  border-radius: 10px;\n  object-fit: cover;\n}\n\n.card-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin: 0 auto;\n  max-width: 1200px;\n  padding: 20px;\n}\n\n.comm-cards {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n  gap: 20px;\n  width: 100%;\n}\n\n/* .committee-card {\n  background-color: #357ABD;\n  color: #fff;\n  padding: 30px;\n  border-radius: 15px;\n  width: 320px;\n  height: 280px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n.committee-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n} */\n\n/* .committee-card {\n  background-image: url(../../src/images/committees/covers/UNSC.jpg);\n  background-size: cover;\n  background-position: center;\n  background-color: #357ABD;\n  color: #fff;\n  padding: px;\n  border-radius: 15px;\n  width: 320px;\n  aspect-ratio: 1;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  transition: transform 0.2s ease-in-out, \n              box-shadow 0.2s ease-in-out,\n              background-image 0.2s ease-in-out;\n}\n.committee-card:hover {\n  transform: translateY(-5px);\n  box-shadow: -3px 3px 15px 2px rgba(0, 0, 0, 0.2);\n  background-image: url(../../src/images/committees/agendas/UNSC\\ agenda.jpg);\n} */\n\n.committee-card {\n  background-size: cover;\n  background-position: center;\n  background-color: #357ABD;\n  color: #fff;\n  padding: 20px;\n  border-radius: 15px;\n  width: 320px;\n  aspect-ratio: 1;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  transition: transform 0.2s ease-in-out,\n    box-shadow 0.2s ease-in-out,\n    background-image 0.2s ease-in-out;\n  position: relative;\n  /* Positioning for overlay */\n  overflow: hidden;\n  /* Hide overflow for the overlay */\n}\n\n.committee-card:hover {\n  transform: translateY(-5px);\n  box-shadow: -3px 3px 15px 2px rgba(0, 0, 0, 0.2);\n}\n\n/* Add an overlay with \"Click for agenda\" text */\n/* .committee-card::before {\n  content: \"Click for agenda\";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.3);\n  color: white;\n  font-size: 1.2rem;\n  font-weight: bold;\n  transition: opacity 0.2s ease-in-out;\n  opacity: 1; \n} */\n\n/* Hide overlay on hover */\n/* .committee-card:hover::before {\n  opacity: 0;\n} */\n/* Default state (covers) */\n.committee-card[data-committee=\"unsc\"] {\n  background-image: url(../../src/images/committees/covers/UNSC.jpg);\n}\n\n.committee-card[data-committee=\"who\"] {\n  background-image: url(../../src/images/committees/covers/WHO.jpg);\n}\n\n.committee-card[data-committee=\"wbnk\"] {\n  background-image: url(../../src/images/committees/covers/WORLD\\ BANK.jpg);\n}\n\n.committee-card[data-committee=\"unodc\"] {\n  background-image: url(../../src/images/committees/covers/UNODC.jpg);\n}\n\n.committee-card[data-committee=\"unfccc\"] {\n  background-image: url(../../src/images/committees/covers/UNFCCC_COP.jpg);\n}\n\n.committee-card[data-committee=\"undp\"] {\n  background-image: url(../../src/images/committees/covers/UNDP.jpg);\n}\n\n.committee-card[data-committee=\"ipc\"] {\n  background-image: url(../../src/images/committees/covers/IPC.jpg);\n}\n\n.committee-card[data-committee=\"ilc\"] {\n  background-image: url(../../src/images/committees/covers/ILC.jpg);\n}\n\n.committee-card[data-committee=\"aippm\"] {\n  background-image: url(../../src/images/committees/covers/AIPPM.jpg);\n}\n\n.committee-card[data-committee=\"copuos\"] {\n  background-image: url(../../src/images/committees/covers/COPUOS.jpg);\n}\n\n.committee-card[data-committee=\"unga\"] {\n  background-image: url(../../src/images/committees/covers/UNGA.jpg);\n}\n\n.committee-card[data-committee=\"unhrc\"] {\n  background-image: url(../../src/images/committees/covers/UNHRC.jpg);\n}\n\n\n\n/* Hover state (agendas) */\n.committee-card:hover[data-committee=\"unsc\"] {\n  background-image: url(../../src/images/committees/agendas/UNSC\\ agenda.jpg);\n}\n\n.committee-card:hover[data-committee=\"who\"] {\n  background-image: url(../../src/images/committees/agendas/who\\ agenda.jpg);\n}\n\n.committee-card:hover[data-committee=\"wbnk\"] {\n  background-image: url(../../src/images/committees/agendas/World\\ bank\\ agenda_.jpg);\n}\n\n.committee-card:hover[data-committee=\"unodc\"] {\n  background-image: url(../../src/images/committees/agendas/UNODC\\ agenda.jpg);\n}\n\n.committee-card:hover[data-committee=\"unfccc\"] {\n  background-image: url(../../src/images/committees/agendas/UNFCCC_COP\\ Agenda.jpg);\n}\n\n.committee-card:hover[data-committee=\"undp\"] {\n  background-image: url(../../src/images/committees/agendas/UNDP\\ AGENDA.jpg);\n}\n\n.committee-card:hover[data-committee=\"ipc\"] {\n  background-image: url(../../src/images/committees/agendas/IPC\\ agenda.jpg);\n}\n\n.committee-card:hover[data-committee=\"ilc\"] {\n  background-image: url(../../src/images/committees/agendas/ILC\\ agenda.jpg);\n}\n\n.committee-card:hover[data-committee=\"aippm\"] {\n  background-image: url(../../src/images/committees/agendas/AIPPM\\ AGENDA.jpg);\n}\n\n.committee-card:hover[data-committee=\"copuos\"] {\n  background-image: url(../../src/images/committees/agendas/COPUOS\\ agenda.jpg);\n}\n\n.committee-card:hover[data-committee=\"unga\"] {\n  background-image: url(../../src/images/committees/agendas/UNGA\\ Agenda.jpg);\n}\n\n.committee-card:hover[data-committee=\"unhrc\"] {\n  background-image: url(../../src/images/committees/agendas/UNHRC\\ agenda.jpg);\n}\n\n\n.committee-card h2 {\n  font-size: 1.5em;\n  font-family: 'Arial', sans-serif;\n  margin-bottom: 15px;\n}\n\n.committee-card h3 {\n  font-size: 1.2em;\n  font-family: 'Arial', sans-serif;\n  line-height: 1.5em;\n  margin: 0;\n}\n\n.committee-card-ipc {\n  background-color: #357ABD;\n  color: #fff;\n  padding: 30px;\n  border-radius: 15px;\n  width: 320px;\n  height: inherit;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n\n.committee-card-ipc:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n}\n\n.info-agendas {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  text-align: center;\n}\n\n.info-agendas-ipc {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  text-align: center;\n}\n\n.cards.leadership-team {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: center;\n}\n\n.sec-gen,\n.director-general,\n.deputy-sec-gen,\n.chief-staff,\n.chief-info {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: center;\n  width: 100%;\n}\n\n\n\n@media (max-width: 768px) {\n\n  .cards,\n  .sec-gen,\n  .director-general,\n  .deputy-sec-gen,\n  .chief-staff,\n  .chief-info {\n    justify-content: space-between;\n  }\n\n  .card {\n    width: 45%;\n  }\n}\n\n@media (max-width: 480px) {\n  .card {\n    width: 100%;\n  }\n\n  .committee-card {\n    width: 100%;\n\n  }\n\n  .about-event__text {\n    display: flex;\n    flex-wrap: wrap;\n  }\n}\n\n@media screen and (min-width: 395px) {\n  .about-event__text {\n    display: flex;\n    flex-wrap: wrap;\n  }\n}\n\n.cardheads {\n  margin-left: 3rem;\n  font-size: 24px;\n}\n\n.cardhead {\n  font-size: 28px;\n  margin-left: 0rem;\n}\n\n/* Card colours for committees */\n\n.aippm {\n  background-color: #af749c;\n}\n\n.disec {\n  background-color: #d17e62;\n}\n\n.sochum {\n  background-color: #b97991;\n}\n\n.unsc {\n  background-color: #951c25;\n}\n\n.undp {\n  background-color: #54968a;\n}\n\n.press {\n  background-color: #dfab1a;\n}\n\n\n/* Card colours for Secretariat */\n.leadership-team .card {\n  background-color: #03045E;\n}\n\n.bdm>.card {\n  background-color: #0C1D6F;\n}\n\n.ihc>.card {\n  background-color: #143680;\n}\n\n.cnd>.card {\n  background-color: #1D4E90;\n}\n\n.hospi>.card {\n  background-color: #2667A1;\n}\n\n.logi>.card {\n  background-color: #2E80B2;\n}\n\n.pr>.card {\n  background-color: #3799C3;\n}\n\n.rnd>.card {\n  background-color: #3FB1D3;\n}\n\n.tech>.card {\n  background-color: #48CAE4;\n}\n\n.committees {\n  display: flex;\n  flex-direction: column;\n  grid-gap: 2rem;\n  gap: 2rem;\n  margin: auto;\n  max-width: 70ch;\n  text-align: center;\n  font-size: 30px;\n  padding-top: 100px;\n  padding-bottom: 200px;\n}\n\n\n\n/* Media queries */\n@media screen and (min-width: 1100px) {\n  .priority {\n    font-size: 1.2em;\n  }\n\n  .priority-2 {\n    font-size: 1.2em;\n  }\n\n  .events-schedule {\n    gap: 40px\n  }\n}\n\n@media screen and (max-width: 1100px) {\n  .events-schedule {\n    gap: 0px\n  }\n\n  .eventstab {\n    margin-top: 50px;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .panelist {\n    flex-direction: column-reverse;\n  }\n\n  .card {\n    width: 130px;\n  }\n\n  .card h3,\n  h4 {\n    font-size: 0.8rem;\n  }\n\n  .card img {\n    height: 100px;\n  }\n}\n\n.heading-wrapper {\n  font-family: \"Unbounded\", sans-serif;\n  color: #0f4c90;\n  font-weight: 700;\n  font-size: 0.8em;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 2rem;\n}\n\n.privacy-policy {\n  width: 80%;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: 'Arial', sans-serif;\n}\n\n.privacy-policy h1 {\n  color: #333;\n  margin-bottom: 1rem;\n}\n\n.privacy-policy h2 {\n  color: #555;\n  margin-top: 1.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.privacy-policy p {\n  color: #666;\n  line-height: 1.6;\n  margin-bottom: 1rem;\n}\n\n.privacy-policy p.date {\n  font-style: italic;\n  margin-bottom: 2rem;\n}\n\n.privacy-policy ul {\n  list-style: disc inside;\n  margin: 1rem 0;\n  padding-left: 1rem;\n}\n\n.privacy-policy li {\n  margin-bottom: 0.5rem;\n  color: #666;\n}\n\n/* sponsors css*/\n.spon-card {\n  background-size: contain; \n  background-position: center;\n  background-repeat: no-repeat;\n  color: #fff;\n  border-radius: 15px;\n  border: 1px solid #143680;\n  width: 230px;\n  aspect-ratio: 1;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  transition: transform 0.2s ease-in-out,\n    box-shadow 0.2s ease-in-out,\n    background-image 0.2s ease-in-out,\n    opacity 0.2s ease-in-out;\n  position: relative;\n  overflow: hidden;\n}\n\n.spon-card:hover {\n  transform: translateY(-10px);\n  opacity: 1;\n  /* Increase opacity on hover */\n}\n\n/* Overlay for the sponsor name */\n.spon-name {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  /* Semi-transparent black background */\n  color: white;\n  padding: 10px;\n  font-size: 1.2em;\n  text-align: center;\n  opacity: 0;\n  /* Hidden by default */\n  transition: opacity 0.3s ease-in-out;\n}\n\n.spon-card:hover .spon-name {\n  opacity: 1;\n  /* Show the sponsor name on hover */\n}\n\n\n.spon-card[data-spon=\"lytads\"] {\n  background-image: url(../images/collabration/collabrations2024/lytads.png);\n}\n\n.spon-card[data-spon=\"lookssalon\"] {\n  background-image: url(../images/collabration/collabrations2024/looks_salon.png);\n}\n\n.spon-card[data-spon=\"amaha\"] {\n  background-image: url(../images/collabration/collabrations2024/amaha.png);\n}\n\n.spon-card[data-spon=\"ilw\"] {\n  background-image: url(../images/collabration/collabrations2024/image.png);\n}\n\n.spon-card[data-spon=\"sultansdeli\"] {\n  background-image: url(../images/collabration/collabrations2024/sultansdeli.png);\n}\n\n.spon-card[data-spon=\"riseup\"] {\n  background-image: url(../images/collabration/collabrations2024/RiseUp.png);\n}\n\n.spon-card[data-spon=\"tiivra\"] {\n  background-image: url(../images/collabration/collabrations2024/tiivra.png);\n}\n\n.spon-card[data-spon=\"bikaji\"] {\n  background-image: url(../images/collabration/collabrations2024/bikaji.jpg);\n}\n\n.spon-card[data-spon=\"inc5\"] {\n \n  background-image: url(../images/collabration/collabrations2024/inc5.png);\n}\n\n.spon-card[data-spon=\"sqube\"] {\n \n  background-image: url(../images/collabration/collabrations2024/sqube.png);\n}\n\n\n.spon-card-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin: 0 auto;\n  max-width: 1200px;\n  padding: 20px;\n}\n\n.spon-cards {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n  gap: 20px;\n  width: 100%;\n}\n\n/* sponsor css end */\n\n.events-schedule {\n  /* height: 600px; */\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.schedule-text {\n  color: white;\n  text-align: left;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.schedule-items {\n  border-radius: 5px;\n  padding-left: 20px;\n  padding-top: 15px;\n  margin-bottom: 3px;\n  padding-bottom: 15px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.schedule-items:nth-child(odd) {\n  background-color: #155498;\n}\n\n.schedule-items:hover {\n  background-color: #2565ad;\n}\n\n.schedule-event {\n  font-weight: bold;\n  margin-left: 5px;\n}\n\n.schedule-pic {\n  height: 450px;\n  width: 100%;\n  margin-top: 10px;\n  border-radius: 20px;\n  border-top-left-radius: 0px;\n  border-top-right-radius: 0px;\n}\n\n.eventstab {\n  height: 500px;\n  width: 315px;\n  text-align: center;\n  border-radius: 20px;\n  background-color: #0e4a8f;\n}\n\n.eventstab h2 {\n  margin-top: 20px;\n  color: white;\n}\n\n.vertical-line {\n  background-color: black;\n  border-radius: 1px;\n  margin-top: 30px;\n  width: 2px;\n  height: 540px;\n}\n\n.all-events {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.events-item {\n  display: flex;\n  flex-wrap: wrap;\n  padding-top: 15px;\n  padding-bottom: 15px;\n  justify-content: center;\n  gap: 50px;\n}\n\n\n\n.event-headings {\n  color: #0e4c8f;\n  font-size: 40px;\n}\n\n.events-item p {\n  font-size: 18px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n.events-img {\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.events-img img {\n  height: auto;\n  width: 95%;\n  border-radius: 20px;\n}\n\n@media screen and (max-width: 1220px) {\n  .events-text {\n    order: 1;\n  }\n\n  .events-img {\n    order: 2;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
